import TitlePlans from "./plans/titlePlans";
import AccordionComponent from "./plans/planAccordion";
import AdditionalFeatures from "./plans/additionalFeatues";
import TitlePlansMobile from "./plans-mobile/titlePlansMobile";
import AccordionComponentMobileFree from "./plans-mobile/planAccordionMobileFree";
import AccordionComponentMobilePremium from "./plans-mobile/planAccordionMobilePremium";
import ToggleButton from "src/components/general/toggleButton";
import { useState } from "react";
import AccordionComponentMobileUltimate from "./plans-mobile/planAccordionMobileUltimate";

const toggleValue = [
  {
    text: "Free",
    value: "Free",
    imageSource: "",
    selectedImageSource: "",
  },
  {
    text: "Premium",
    value: "Premium",
    imageSource: "",
    selectedImageSource: "",
  },
  {
    text: "Ultimate",
    value: "Ultimate",
    imageSource: "",
    selectedImageSource: "",
  },
];

const Plans = () => {
  const [tabToggleValue, SetTabToggleValues] = useState("Free");

  const handleTabToggleChange = (value: any) => {
    SetTabToggleValues(value);
  };

  return (
    <>
      <div className="lg:flex lg:flex-col hidden">
        <TitlePlans />
        <AccordionComponent />
        <AdditionalFeatures />
      </div>
      <div className="flex flex-col lg:hidden">
        <TitlePlansMobile />
        <ToggleButton
          ToggleValues={toggleValue}
          DefaultValue={tabToggleValue}
          isTransparent={true}
          OnValueChange={handleTabToggleChange}
          buttonColor="data-[state=on]:text-brand-blue"
        />
        {tabToggleValue === "Free" ? (
          <AccordionComponentMobileFree />
        ) : tabToggleValue === "Premium" ? (
          <AccordionComponentMobilePremium />
        ) : (
          <AccordionComponentMobileUltimate />
        )}
      </div>
    </>
  );
};

export default Plans;
